var tools = {}
tools.arrayRemove = function (arr, el) {
   let index = arr.indexOf(el);
   arr.splice(index,1);
   return arr;
} 

export default tools
